<!--
 * @Author: 范向玲
 * @Date: 2022-12-06 15:39:08
 * @LastEditTime: 2024-04-16 17:59:02
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 走势库数据管理--批量新增
 * @FilePath: \web\src\components\ProjectPerformance\DataManager\importData.vue
-->
<template>
  <section class="trend-import-container">
    <section class="fileDown" @click="importFileDown">数据模板下载</section>
    <section class="fileUpload">
      <FileUpload @fileList="fileList"  uploadType=".xlsx,.xls"/>
    </section>
  </section>
</template>

<script setup>
import { ref, reactive, defineEmits, toRefs, watch, onMounted, onBeforeMount, } from 'vue';
import { trendDataFileDownApi, } from '@/api/projectPerformance/dataManager.js';
import { getMineralImage, downLoadUtil, } from '@/components/utils/utils';
import config from '@/config/config';
import storage from '@/utils/storage';
import FileUpload from '@/components/lib/Upload/fileUpload.vue';

// emit
const emit = defineEmits(['fileList',]);

const optionConf = reactive({
  fileList: [],
});

/* 文件上传模板下载 */
const importFileDown = () => {
  trendDataFileDownApi().then(res => {
    downLoadUtil(res).then(() => {});
  }).catch(() => {});
};

const fileList = (data) => {
  emit('fileList', data);
};


</script>

<style lang="scss">
/* 弹出页样式 */
.trend-import-container {
  /* 模板下载 */
  .fileDown {
    width: 20%;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    background-image: url(~@/static/images/dataManagement/submit_btn.png);
    background-size: 100% 100%;
  }
  .fileDown:hover {
    cursor: pointer;
  }
  /* 文件上传 */
  .fileUpload {
    margin-top: 0.1rem;
  }
}
</style>